{
  "already_host": "Dieser Durchlauf läuft bereits auf Ihrem PC.",
  "approvals_missing": "Es fehlen noch Freigaben.",
  "blocked": {
    "administrator": "Die Administration kann Sie hinzufügen.",
    "ask": "Anfragen",
    "canAdd_one": "{{names}} kann Sie hinzufügen.",
    "canAdd_other": "{{names}} können Sie hinzufügen.",
    "haveIt": "{{groups}} haben es.",
    "need": "Dafür brauchen Sie „{{permission}}“",
    "reason": "Warum (optional)",
    "requested": "Angefragt am {{date}}.",
    "withdraw": "Zurückziehen"
  },
  "change_set_state": "Dieser Änderungssatz ist gerade nicht im Review.",
  "closed": "Dieser Durchlauf ist geschlossen. Forken Sie ihn, um weiterzumachen.",
  "curates_none": "Sie kuratieren nichts, was er ändert.",
  "dmw_core": "Das eigene Projekt von DMW ist schreibgeschützt.",
  "merge_blocked": "Etwas verhindert die Übernahme.",
  "missing_permission": "Dafür fehlt Ihnen eine Berechtigung.",
  "no_active_workflow": "Dieser Durchlauf folgt gerade keinem Prozessschema.",
  "not_deletable": "Dieses Projekt kann nicht gelöscht werden.",
  "not_host": "Das kann nur die Person, auf deren PC der Durchlauf läuft. Führen Sie ihn auf Ihrem PC aus, um es selbst zu tun.",
  "not_own_route": "Das läuft auf Ihrem eigenen Agenten: Führen Sie den Durchlauf auf Ihrem PC aus, um es auszuführen.",
  "nothing_to_review": "Hier gibt es nichts für ein Review.",
  "project_not_active": "Dieses Projekt ist nicht aktiv.",
  "request_waiting": "Ein Personenschritt wartet auf seine Antwort. Beantworten Sie ihn zuerst.",
  "saved_not_host": "Dieser Durchlauf ist nicht verbunden: Bis er es wieder ist, kann das nur die Person, auf deren PC er läuft.",
  "step_already_ran": "Der Durchlauf läuft nur bis zu einem Schritt, der noch nicht gelaufen ist.",
  "step_not_answerable": "Sein Durchlauf wartet nicht mehr auf diese Antwort.",
  "step_not_skippable": "Dieser Schritt kann gerade nicht übersprungen werden.",
  "turn_open": "Warten Sie, bis der Agent fertig ist."
}
